export default __webpack_public_path__ + "static/media/BMWGroupCondensed-Regular.07bdf79e.woff";